<ng-container *ngIf="accesoAltaReservasPublico">
    <section class="reservar">
        <picture *ngIf="bgrLandscape?.ruta">
            <!-- <source media="(orientation: portrait)" [srcset]="bgrPortrait['ruta']"/> -->
            <img [src]="bgrLandscape['ruta']" alt="" />
        </picture>
        <div class="container">
            <a class="btn btn-secondary" (click)="onSalir()">
                <neo-icono [iconoClase]="'icon-24 icon-ibm-arrow_left'"></neo-icono>
                <span>salir</span>
            </a>
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="formulario" *ngIf="!existeBusqueda">
                        <h1>Haz tu reserva</h1>
                        <neo-notificacion #notificacion [id]="'notificacion_general'" [identificador]="'notificacion_general'">
                        </neo-notificacion>

                        <neo-formulario #formularioBusqueda [valoresIniciales]="valoresInicialesBusqueda()" [camposFormulario]="formInputPaso1"
                            [aplicarFlex]="true" [formularioAncho]="formularioAncho"
                            (changeValueForm)="onCambioFormulario($event, 'formInputPaso1')">
                        </neo-formulario>
                        <!-- extras -->
                        <ng-container
                            *ngIf="(reservaService.idTipoEvento$ | async) != tiposEventosEnum.Otros && (reservaService.idTipoEvento$ | async) != tiposEventosEnum.Comuniones">
                            <ng-container *ngIf="paquetesService.paquete$ | async as paquete">
                                <div class="formulario-extra-opcional"
                                    [ngClass]="{'formulario-extra-opcional-multiple': paquete.numeroExtrasOpcionales > 1, 'formulario-extra-opcional-unica': paquete.numeroExtrasOpcionales <= 1}"
                                    *ngIf="existenExtrasOpcionales() && paquete.numeroExtrasOpcionales >= 1">
                                    <div class="titulo-formulario">
                                        <h2>
                                            {{ 'Selecciona ' + paquete.numeroExtrasOpcionales + (paquete.numeroExtrasOpcionales > 1 ? ' actividades ' : ' actividad
                                            ') + ' de las siguientes' }}
                                            </h2>
                                            </div>
                                    <neo-formulario #formularioExtrasOpcionalUnica *ngIf="paquete.numeroExtrasOpcionales == 1"
                                        [identificador]="'formularioExtrasOpcionalUnica'" [camposFormulario]="formInputExtrasOpcionalUnica"
                                        [aplicarFlex]="false" [formularioAncho]="formularioAncho"
                                        (changeValueForm)="onCambioFormulario($event, 'formularioExtrasOpcionalUnica')">
                                    </neo-formulario>
                                    <neo-notificacion #notificacion_formularioExtrasOpcionalMultiple [id]="'notificacion_formularioExtrasOpcionalMultiple'"
                                        [identificador]="'notificacion_formularioExtrasOpcionalMultiple'"></neo-notificacion>
                                    <neo-formulario #formularioExtrasOpcionalMultiple *ngIf="paquete.numeroExtrasOpcionales > 1"
                                        [identificador]="'formularioExtrasOpcionalMultiple'" [camposFormulario]="formInputExtrasOpcionalMultiple"
                                        [aplicarFlex]="false" [formularioAncho]="formularioAncho"
                                        (changeValueForm)="onCambioFormulario($event, 'formularioExtrasOpcionalMultiple', paquete)">
                                    </neo-formulario>
                                    </div>
                                <div class="formulario-extra" *ngIf="existenExtras()">
                                    <div class="titulo-formulario ">
                                        <h2>
                                            Extras
                                        </h2>
                                    </div>
                                    <neo-formulario #formularioExtras [camposFormulario]="undefined" [aplicarFlex]="false"
                                        [identificador]="'formularioExtras'"
                                        [formularioAncho]="formularioAncho" (changeValueForm)="onCambioFormulario($event, 'formularioExtras')">
                                    </neo-formulario>
                                </div>
                            </ng-container>
                        </ng-container>

                        <neo-formulario-contacto-evento
                            *ngIf="(reservaService.idTipoEvento$ | async) == tiposEventosEnum.Otros || (reservaService.idTipoEvento$ | async) == tiposEventosEnum.Comuniones">
                        </neo-formulario-contacto-evento>
                        <div class="formulario-footer"
                            *ngIf="(reservaService.idTipoEvento$ | async) != tiposEventosEnum.Otros && (reservaService.idTipoEvento$ | async) != tiposEventosEnum.Comuniones">
                            <neo-button [text]="'Cancelar'" [color]="''" [basic]="true" [clase]="'btn-transparent'" [disabled]="procesando"
                                (accion)="onCancelar()"></neo-button>
                            <neo-button class="btn-submit-contacto"
                                [text]="((reservaService.idTipoEvento$ | async) == tiposEventosEnum.Otros || (reservaService.idTipoEvento$ | async) == tiposEventosEnum.Comuniones) ? 'Enviar' : 'Continuar'"
                                [color]="'primary'" [raised]="true" [disabled]="procesando" (accion)="onContinuar()">
                            </neo-button>
                        </div>
                    </div>
                    <div class="formulario" *ngIf="existeBusqueda">
                        <h1>Configura tu cumpleaños</h1>
                        <neo-notificacion #notificacion [id]="'notificacion'" [identificador]="'notificacion'"></neo-notificacion>
                        <!-- wizard -->
                        <neo-formulario-wizard-cumpleanos #formularioReservaWizard (modificarBusqueda)="confirmarBusqueda(false)">
                        </neo-formulario-wizard-cumpleanos>

                        <div class="formulario-footer" *ngIf="formularioReservaWizard.indexStepActual < 5">
                            <neo-button [text]="'Atrás'" [color]="''" [basic]="true" [clase]="'btn-transparent'"
                                *ngIf="!reservaService.esPagoCorrecto()"
                                [disabled]="procesando || reservaService.esPagoCorrecto() " (accion)="onAtras()">
                            </neo-button>
                            <neo-button class="btn-submit-contacto"
                                *ngIf="formularioReservaWizard.indexStepActual<3 && !reservaService.esPagoCorrecto()"
                                [text]="((reservaService.idTipoEvento$ | async) == tiposEventosEnum.Otros || (reservaService.idTipoEvento$ | async) == tiposEventosEnum.Comuniones) ? 'Enviar' : 'Continuar'"
                                [color]="'primary'" [raised]="true" [disabled]="procesando"
                                (accion)="onContinuarConfiguracion()"></neo-button>
                            <neo-button class="btn-submit-contacto" *ngIf="formularioReservaWizard.indexStepActual==3"
                                [text]="'Reservar'" [color]="'primary'" [raised]="true"
                                [disabled]="procesando && !reservaService.esPagoCorrecto() || (reservaService.grabando$ | async)"
                                (accion)="onReservar()"></neo-button>
                            <neo-button class="btn-submit-contacto"
                                *ngIf="formularioReservaWizard.indexStepActual==4 && !reservaService.esPagoCorrecto()"
                                [text]="'Pagar'" [color]="'primary'" [raised]="true"
                                [disabled]="procesando || formularioReservaWizard?.procesandoPago" (accion)="onPagar()">
                            </neo-button>
                        </div>
                        <div class="formulario-footer2" *ngIf="formularioReservaWizard.indexStepActual == 5">
                            <neo-button class="btn-submit-contacto" [text]="'Volver al inicio'" [color]="''" [basic]="true"
                                [clase]="'btn-transparent'" [disabled]="procesando" (accion)="onSalir()">
                            </neo-button>
                            <neo-button class="btn-submit-contacto" *ngIf="reservaService.esPagoCorrecto()" [text]="'Gestionar mi reserva'"
                                [color]="'accent'" [raised]="true" [disabled]="procesando" (accion)="onGestionarMiReserva()"></neo-button>
                            <neo-button class="btn-submit-contacto" *ngIf="!reservaService.esPagoCorrecto()" [text]="'Volver a intentarlo'"
                                [color]="'accent'" [raised]="true" [disabled]="procesando" (accion)="onVolverAIntentarlo()">
                            </neo-button>
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>
                            </section>
                            <neo-main-footer [elementosMenu]="[]" [menuIdiomas]="false">
                            </neo-main-footer>
</ng-container>
